<template>
	<div class="layout">
		<div id="layout-title">
			<div id="layout-title-left">
				<img src="/static/imgs/gongying.png" class="jxyd-imgicon"/>
				供应商管理
			</div>
			<div id="layout-title-right">
				<Dropdown style="margin-right:10px;">
					<a href="javascript:void(0)" class="jxyd-a">
						下载模板
						<Icon type="ios-arrow-down"></Icon>
					</a>
					<DropdownMenu slot="list">
						<DropdownItem>
							<a href="/static/供应商导入模板.xlsx" class="jxyd-a">供应商数据模板</a>
						</DropdownItem>
					</DropdownMenu>
				</Dropdown>
				<button class="jxyd-button" title="新建供应商" @click="addSupplier"
					style="margin-right:10px;" v-show="permission.isAdd">
					<Icon type="md-add-circle" size='18'/> 新建
				</button>
				<a href="javascript:void(0)" @click="handleDownLoad" class="jxyd-button" style="margin-right:10px;"
					v-show="permission.isExport">
					<Icon type="md-open" size='18'/> 导出
				</a>
				<Dropdown @on-click="batchFunc">
					<a href="javascript:void(0)" class="jxyd-a">
						批量操作
						<Icon type="ios-arrow-down"></Icon>
					</a>
					<DropdownMenu slot="list">
						<Upload action="/api/Util/UploadExcel" style="display:inline-block;" :show-upload-list="false"
							:max-size="2048" :format="['xlsx','xls']" :on-format-error="batchAddSupplierFormatError"
							:on-exceeded-size="uploadFileSizeError" :on-success="batchAddSupplierSuccess"
							:on-error="batchAddSupplierError" v-show="permission.isBatchImport">
							<DropdownItem class="dropdown-item">
								<Icon type="md-exit" size='18'/> 批量导入
							</DropdownItem>
						</Upload>
						<DropdownItem name='batchDele' v-show="permission.isDelete" class="dropdown-item">
							<Icon type="md-trash" size='18'/> 删除
						</DropdownItem>
					</DropdownMenu>
				</Dropdown>
			</div>
		</div>

		<div id="layout-box">
			<div id="box-search">
				<Form ref="formSearch" :label-width="70" :model="searchItems" inline>
					<Row :gutter="16">
						<Col :lg="6" :md="24">
						<FormItem label="供应商" style="width:100%">
							<Input type="text" v-model="searchItems.name" placeholder="请输入供应商"
								@keyup.enter.native="initListData(1)" />
						</FormItem>
						</Col>
						<Col :lg="6" :md="24">
						<FormItem label="供应商类" style="width:100%">
							<Input type="text" v-model="searchItems.supplyGoods" placeholder="请输入供应商类"
								@keyup.enter.native="initListData(1)" />
						</FormItem>
						</Col>
						<Col :lg="6" :md="24">
						<FormItem label="联系人" style="width:100%">
							<Input type="text" v-model="searchItems.contact" placeholder="请输入联系人"
								@keyup.enter.native="initListData(1)" />
						</FormItem>
						</Col>
						<Col :lg="6" :md="24">
						<FormItem label="是否启用" style="width:100%">
							<Select v-model="searchItems.isUse" @on-change="initListData(1)">
								<Option :value="-1" :key="-1">请选择</Option>
								<Option :value="0" :key="0">否</Option>
								<Option :value="1" :key="1">是</Option>
							</Select>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="16" v-show="advancedSelect">
						<Col :lg="6" :md="24">
						<FormItem label="电话" style="width:100%">
							<Input type="text" v-model="searchItems.telePhone" placeholder="请输入电话"
								@keyup.enter.native="initListData(1)" />
						</FormItem>
						</Col>
						<Col :lg="6" :md="24">
						<FormItem label="折扣" style="width:100%">
							<Input type="text" v-model="searchItems.discount" placeholder="请输入折扣"
								@keyup.enter.native="initListData(1)" />
						</FormItem>
						</Col>
						<Col :lg="6" :md="24">
						<FormItem label="经营地址" style="width:100%">
							<Input type="text" v-model="searchItems.address" placeholder="请输入经营地址"
								@keyup.enter.native="initListData(1)" />
						</FormItem>
						</Col>
						<Col :lg="6" :md="24">
						<FormItem label="备注" style="width:100%">
							<Input type="text" v-model="searchItems.note" placeholder="请输入备注"
								@keyup.enter.native="initListData(1)" />
						</FormItem>
						</Col>
					</Row>
					<FormItem :label-width="20">
						<button class="jxyd-button jxyd-primary" @click="initListData(1)"
							style="margin-right:10px;">查询</button>
						<button class="jxyd-button" @click="initSearch" style="margin-right:10px;">重置</button>
						<span @click="advancedSelect = true;" style="color:red;cursor: pointer;" v-if="!advancedSelect">
							展开
							<Icon type="ios-arrow-down" size='18'/>
						</span>
						<span @click="foldSearch" style="color:red;cursor: pointer;" v-else>
							折叠
							<Icon type="ios-arrow-up" size='18'/>
						</span>
					</FormItem>
				</Form>
			</div>
			<div id="box-table">
				<Table row-key="guid" ref="supplierList" :columns="tableColumns" :data="supplierData"
					@on-selection-change="supplierListSeleChange"></Table>
			</div>
			<div id="page-box">
				<Page show-sizer :total="supplierCount" :page-size="searchItems.pageSize" @on-change="pageChange"
					show-total show-elevator :page-size-opts='pageSizeOpts' :current="searchItems.pageIndex"
					@on-page-size-change='pageSizeChange'>
				</Page>
			</div>
		</div>

		<Modal v-model="modalDisPlay" draggable sticky scrollable :width="900"
			:styles="{top: '20px'}">
			<p slot="header" class="modal-header">
				<img src="/static/imgs/gongying.png" class="jxyd-imgicon"/>
				<span> 操作供应商</span>
			</p>
			<Form ref="formSupplier" :model="formItem" :label-width="90" :rules="ruleSupplier">
				<table style="width:100%;background-color:#fff;padding:20px;border-radius:5px;">
					<tr>
						<td>
							<Form-item label="供应商" prop="name">
								<Input v-model="formItem.name" placeholder="请输入供应商" size="default" />
							</Form-item>
						</td>
						<td>
							<Form-item label="联系人" prop="contact">
								<Input v-model="formItem.contact" placeholder="请输入联系人" size="default" />
							</Form-item>
						</td>
					</tr>
					<tr>
						<td width="50%">
							<Form-item label="供应商品类" prop="supplyGoods">
								<SelectConfig ref="selectConfig" :sc_type='supplyGoodPid' :sc_data="formItem.supplyGoods"
									:sc_multiple="true" sc_size="small"></SelectConfig>
							</Form-item>
						</td>
					</tr>
					<tr>
						<td>
							<Form-item label="折扣(%)" prop="discount">
								<Input v-model="formItem.discount" placeholder="请输入折扣" size="default" />
							</Form-item>
						</td>
						<td>
							<Form-item label="电话" prop="telePhone">
								<Input v-model="formItem.telePhone" placeholder="请输入电话" size="default" />
							</Form-item>
						</td>
					</tr>
					<tr>
						<td colspan="2">
							<Form-item label="经营地址" prop="address">
								<Input type="textarea" v-model="formItem.address" placeholder="请输入经营地址" size="default" />
							</Form-item>
						</td>
					</tr>
				</table>
				<Divider>扩展信息</Divider>
				<div style="background-color: #fff; padding: 20px;border-radius:5px;">
					<Form-item label="开户行" prop="bankName">
						<Input v-model="formItem.bankName" placeholder="请输入开户行" size="default" />
					</Form-item>

					<Form-item label="银行账号" prop="bankID">
						<Input v-model="formItem.bankID" placeholder="请输入银行账号" size="default" />
					</Form-item>

					<Form-item label="银行账户" prop="bankAccount">
						<Input v-model="formItem.bankAccount" placeholder="请输入银行账户" size="default" />
					</Form-item>

					<Form-item label="备注" prop="note">
						<Input v-model="formItem.note" type="textarea" placeholder="请输入备注" size="default" />
					</Form-item>
				</div>

			</Form>
			<div slot="footer">
				<button class="jxyd-button" @click="cancel('formSupplier')">取消</button>
				<Button class="jxyd-borderbtn" @click="supplierSubmit(1)">保存</Button>
				<Button class="jxyd-borderbtn" @click="supplierSubmit(2)">保存并继续</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import SelectConfig from '@/components/SelectConfig'
	export default {
		name: 'suppliermanage',
		components: {
			SelectConfig
		},
		data() {
			return {
				searchItems: {
					name: '',
					contact: '',
					supplyGoods: '',
					isUse: -1,
					telePhone: '',
					discount: '',
					address: '',
					note: '',
					pageSize: 10,
					pageIndex: 1,
				},
				supplierCount: 0,
				modalDisPlay: false,
				tableColumns: [{
						type: 'selection',
						width: 60,
						fixed: 'left',
						align: 'center'
					},
					{
						title: '供应商',
						key: 'name',
						width: 300
					},
					{
						title: '联系人',
						width: 150,
						key: 'contact'
					},
					{
						title: '供应商品类',
						width: 200,
						key: 'supplyGoods'
					},
					{
						title: '是否启用',
						key: 'isUse',
						width: 150,
						render: (h, params) => {
							return h('i-Switch', {
								attrs: {
									'value': params.row.isUse,
									'disabled': !this.permission.isUpdateUse
								},
								on: {
									'on-change': (e) => {
										params.row.isUse = e;
										let self = this;
										let tag = '';
										if (e) {
											tag = '启用';
										} else {
											tag = '停用';
										}
										this.$Modal.confirm({
											title: "操作警告",
											content: "是否确认" + tag + "“" + params.row.name +
												"”供应商？",
											onOk() {
												request.get('/api/Supplier/EditUse', {
													params: {
														id: params.row.id,
														isUse: e
													}
												}).then(function(response) {
													if (response.state == 0) {
														self.$Notice.error({
															title: '错误提示',
															duration: 3,
															desc: '更新失败:' +
																response
																.errorMsg
														});
														return;
													}
													self.$Notice.success({
														title: '正确提示',
														duration: 3,
														desc: '更新成功!'
													});
												}).catch(function(error) {
													params.row.isUse = !e;
												})
											},
											onCancel() {
												params.row.isUse = !e;
											}
										});
									}
								}
							})
						}
					},
					{
						title: '联系电话',
						key: 'telePhone',
						width: 200,
					},
					{
						title: '折扣',
						key: 'discount',
						width: 150,
					},
					{
						title: '经营地址',
						width: 300,
						key: 'address'
					},
					{
						title: '操作',
						key: 'action',
						width: 140,
						align: 'center',
						fixed: 'right',
						render: (h, params) => {
							var btnArr = [];
							if (this.permission.isEdit) {
								btnArr.push(h('a', {
									attrs: {
										class: "jxyd-a"
									},
									on: {
										click: (e) => {
											let component = this;
											request.get('/api/Supplier/GetSupplier', {
												params: {
													id: params.row.id
												}
											}).then(function(response) {
												if (response.state == 0) {
													component.$Notice.error({
														title: '错误提示',
														duration: 3,
														desc: response.errorMsg
													});
													return;
												}
												component.initForm(response.data);
												component.modalDisPlay = true;
											}).catch(function(error) {})
										}
									},
								}, "编辑"));
							}
							return btnArr;
						}
					}
				],
				supplierData: [],
				formItem: {
					id: 0,
					name: '',
					supplyGoods: [],
					contact: '',
					telePhone: '',
					address: '',
					discount: '100',
					bankName: '',
					bankID: '',
					bankAccount: '',
					note: '',
					creator: parseInt(localStorage.getItem("userId")),
					isUse: true
				},
				ruleSupplier: {
					name: [{
							required: true,
							message: '请填写供应商名',
							trigger: 'blur'
						},
						{
							type: 'string',
							max: 20,
							message: '输入不得大于20个字',
							trigger: 'blur'
						}
					],
					contact: [{
							required: false,
							message: '请填写联系人',
							trigger: 'blur'
						},
						{
							type: 'string',
							max: 20,
							message: '输入不得大于20个字',
							trigger: 'blur'
						}
					],
					supplyGoods: [{
							required: false,
							message: '请选择供应商品类',
							trigger: 'change',
							transform: (value) => {
								this.formItem.supplyGoods = this.$refs.selectConfig.getValue();
								return this.formItem.supplyGoods;
							}
						},
						{
							type: 'string',
							max: 20,
							message: '输入不得大于20个字',
							trigger: 'blur'
						}
					],
					telePhone: [{
							required: false,
							message: '请填写电话',
							trigger: 'blur'
						},
						{
							type: 'string',
							max: 11,
							message: '电话号最大为11位',
							trigger: 'blur'
						}
					],
					address: [{
							required: false,
							message: '请填写经营地址',
							trigger: 'blur'
						},
						{
							type: 'string',
							max: 50,
							message: '输入不得大于50个字',
							trigger: 'blur'
						}
					],
					discount: [{
						required: true,
						validator: this.validateDiscount,
						trigger: 'blur'
					}],
					bankName: [{
							required: false,
							message: '请填写开户行',
							trigger: 'blur'
						},
						{
							type: 'string',
							max: 20,
							message: '输入不得大于20个字',
							trigger: 'blur'
						}
					],
					bankID: [{
							required: false,
							message: '请填写银行账号',
							trigger: 'blur'
						},
						{
							type: 'string',
							max: 20,
							message: '输入不得大于20个字',
							trigger: 'blur'
						}
					],
					bankAccount: [{
							required: false,
							message: '请填写银行账户',
							trigger: 'blur'
						},
						{
							type: 'string',
							max: 20,
							message: '输入不得大于20个字',
							trigger: 'blur'
						}
					],
					note: [{
							required: false,
							message: '',
							trigger: 'blur'
						},
						{
							type: 'string',
							max: 50,
							message: '输入不得大于50个字',
							trigger: 'blur'
						}
					]
				},
				tableRowIds: [],
				supplyGoodPid: 'gyspl',
				advancedSelect: false,
				permission: {
					isAdd: false,
					isEdit: false,
					isDelete: false,
					isBatchImport: false,
					isUpdateUse: false,
					isExport: false
				},
				pageSizeOpts: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100]
			}
		},

		methods: {
			initListData(index) {
				let component = this;
				component.searchItems.pageIndex = index;
				request.post('/api/Supplier/GetSupplierList', component.searchItems).then(function(response) {
					if (response.state == 0) {
						component.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}
					component.supplierData = response.data.supplier;
					component.supplierCount = response.data.supplierCount;
				}).catch(function(error) {})
			},
			supplierSubmit(type) {
				this.$refs['formSupplier'].validate((valid) => {
					if (valid) {
						let component = this;
						component.formItem.discount = parseFloat(component.formItem.discount).toFixed(2);
						request.post('/api/Supplier/EditSupplier', component.formItem).then(function(response) {
							if (response.state == 0) {
								component.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: '保存失败:' + response.errorMsg
								});
								return;
							}

							component.initListData(1);
							component.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '保存成功!'
							});
							if (type == 1) {
								component.modalDisPlay = false;
							} else {
								component.$refs['formSupplier'].resetFields();
								component.formItem.id = 0;
							}
						}).catch(function(error) {})
					}
				})
			},
			cancel(name) {
				this.modalDisPlay = false;
				//清空form规则检查
				this.$refs[name].resetFields();
			},
			supplierListSeleChange(items) {
				this.tableRowIds = [];
				for (var i = 0; i < items.length; i++) {
					this.tableRowIds.push(items[i].id);
				}
			},
			addSupplier() {
				this.modalDisPlay = true;
				this.$refs['formSupplier'].resetFields();
				this.formItem.id = 0;
			},
			deleteSupplier() {
				if (this.tableRowIds.length <= 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '请选中要删除的供应商！'
					});
					return;
				}
				var component = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: "供应商删除后不可恢复，是否继续操作？",
					onOk() {
						request.post('/api/Supplier/DeleSupplier', component.tableRowIds).then(function(response) {

							if (response.state == 0) {
								component.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: response.errorMsg
								});
								return;
							}
							component.initListData(1);
							component.tableRowIds = [];
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			pageChange(index) {
				this.initListData(index);
			},
			pageSizeChange(pageSize) {
				this.searchItems.pageSize = pageSize;
				this.initListData(1);
			},
			initForm(data) {
				this.formItem.id = data.id;
				this.formItem.name = data.name;
				this.formItem.supplyGoods = data.supplyGoods.split(',');
				this.formItem.contact = data.contact;
				this.formItem.telePhone = data.telePhone;
				this.formItem.address = data.address;
				this.formItem.discount = data.discount;
				this.formItem.bankName = data.bankName;
				this.formItem.bankID = data.bankID;
				this.formItem.bankAccount = data.bankAccount;
				this.formItem.note = data.note;
				this.formItem.creator = data.creator;
				this.formItem.createDate = data.createDate;
			},
			validateDiscount(rule, value, callback) {
				if (value == '') {
					callback(new Error('折扣不可为空'));
				} else if (isNaN(value)) {
					callback(new Error('输入数字'));
				} else if (parseInt(value) < 1 || parseInt(value) > 100) {
					callback(new Error('不得小于1，大于100'));
				} else {
					callback();
				}
			},
			batchAddSupplierSuccess(response, file, fileList) {
				if (response.state == 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '导入失败：' + response.errorMsg + '!'
					});
					return;
				}
				let component = this;
				request.post('/api/Supplier/BatchAddSupplier', {
					Path: response.data,
					Creator: localStorage.getItem("userId")
				}).then(function(response) {
					if (response.state == 0) {
						component.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "导入失败：" + response.errorMsg
						});
						return;
					}

					component.initListData(1);
				}).catch(function(error) {})
			},
			batchAddSupplierError(error, file, fileList) {
				this.$Notice.error({
					title: '错误提示',
					duration: 3,
					desc: '上传失败：' + error + '!'
				});
			},
			batchAddSupplierFormatError(file) {
				this.$Notice.error({
					title: '错误提示',
					duration: 3,
					desc: '导入失败：请选择xls、xlsx格式文件！'
				});
			},
			uploadFileSizeError(file) {
				this.$Notice.error({
					title: '错误提示',
					duration: 3,
					desc: '导入失败：不可选择超过2M大小文件！'
				});
			},
			foldSearch() {
				this.advancedSelect = false;
				this.searchItems.telePhone = '';
				this.searchItems.discount = '';
				this.searchItems.address = '';
				this.searchItems.note = '';
			},
			initSearch() {
				this.searchItems.name = '';
				this.searchItems.contact = '';
				this.searchItems.supplyGoods = '';
				this.searchItems.isUse = -1;
				this.searchItems.telePhone = '';
				this.searchItems.discount = '';
				this.searchItems.address = '';
				this.searchItems.note = '';
			},
			initPermission() {
				let self = this;
				let params = {
					funcCodes: ['Supplier.Add', 'Supplier.Edit', 'Supplier.Delete', 'Supplier.BatchImport',
						'Supplier.UpdateUse', 'Supplier.Export'
					],
					userId: parseInt(localStorage.getItem("userId"))
				};
				request.post('/api/Function/VerifyPermissions', params).then(function(response) {
					let tipTimeoutCount = localStorage.getItem("_tipTimeoutCount")
					if(tipTimeoutCount != undefined){
						tipTimeoutCount = parseInt(tipTimeoutCount);
					}
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取权限数据失败：" + response.errorMsg
						});
						return;
					}else if(response.state == 2 && (tipTimeoutCount == undefined || tipTimeoutCount >= 1000)){
						self.$Modal.warning({
							title:'系统到期提示',
							content: response.errorMsg,
							onOk:() => {
								localStorage.setItem("_tipTimeoutCount",1);
							}
						});
					}
					if(tipTimeoutCount == undefined || tipTimeoutCount < 1000){
						localStorage.setItem("_tipTimeoutCount",tipTimeoutCount == undefined ? 1 : tipTimeoutCount+1)
					}
					for (var i = 0; i < response.data.length; i++) {
						switch (response.data[i].funcCode) {
							case 'Supplier.Add':
								self.permission.isAdd = response.data[i].permission
								break;
							case 'Supplier.Edit':
								self.permission.isEdit = response.data[i].permission
								break;
							case 'Supplier.Delete':
								self.permission.isDelete = response.data[i].permission
								break;
							case 'Supplier.BatchImport':
								self.permission.isBatchImport = response.data[i].permission
								break;
							case 'Supplier.UpdateUse':
								self.permission.isUpdateUse = response.data[i].permission
								break;
							case 'Supplier.Export':
								self.permission.isExport = response.data[i].permission
								break;
						}
					}
				}).catch(function(error) {})
			},
			handleDownLoad() {
				let self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: "是否导出列表数据？",
					onOk() {
						fetch('/api/Util/ExportSupplierListExcel', {
								method: 'POST',
								headers: new Headers({
									'Authorization': window.localStorage.getItem('token'),
									'Schema': window.localStorage.getItem('schema'),
									'WorkShop':window.localStorage.getItem('workshop'),
									'Content-Type': 'application/json;charset=UTF-8',
									'Accept': 'application/octet-stream' // 明确接受二进制流
								}),
								body: JSON.stringify(self.searchItems)
							})
							.then(res => res.blob())
							.then(data => {
								const blobUrl = window.URL.createObjectURL(data);
								self.download(blobUrl);
							});
					},
					onCancel() {}
				});
			},
			download(blobUrl) {
				const a = document.createElement('a');
				a.download = '供应商信息' + '.xlsx';
				a.href = blobUrl;
				a.click();
			},
			batchFunc(name){
				switch(name){
					case 'batchDele':
						this.deleteSupplier()
					break;
					case 'createCode':
						this.createCode()
					break;
				}
			},
		},
		watch: {},
		created: function() {
			this.initListData(1);
			this.initPermission();
		}
	}
</script>

<style scoped>
	.layout {
		background: #fff;
		border-radius: 8px;
		padding: 5px 10px;
	}

	#layout-title {
		overflow: hidden;
		padding: 5px;
		font-size: 16px;
		border-bottom: 1px solid #e8eaec;
	}

	#box-search {
		padding-top: 20px;
	}

	#layout-title-left {
		float: left;
		height: 25px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	#layout-title-right {
		float: right;
	}

	#page-box {
		margin-top: 20px;
		text-align: center;
	}
	
	.dropdown-item{
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.modal-header{
		display: flex;
		justify-content: left;
		align-items: center;
	}
</style>